import { Link } from 'react-router-dom'

/** Placeholder until we add bakery products/cart; can later mirror grocery flow with bakery catalog */
export function BakeryShopView() {
  return (
    <div className="page page--bakery-shop">
      <header className="bakery-shop-header">
        <Link to="/bakery" className="btn-back" aria-label="Back to bakery">←</Link>
        <h1 className="page-title">🛒 Bakery Shop</h1>
      </header>
      <div className="empty-state">
        <span className="empty-state-emoji" aria-hidden>🧁</span>
        <h2 className="empty-state-title">Shop coming soon</h2>
        <p className="empty-state-p">
          For now, try <strong>Bake</strong> – pick a recipe and make something step by step!
        </p>
        <Link to="/bakery/bake" className="btn-large btn-primary" style={{ textDecoration: 'none' }}>
          Go bake
        </Link>
        <Link to="/bakery" className="btn-large btn-secondary" style={{ textDecoration: 'none', marginTop: 12 }}>
          Back to Bakery
        </Link>
      </div>
    </div>
  )
}
